import type { Werte } from "./modell.ts";

const PLATZHALTER = /\{([a-z0-9_]+)(\.\.\.)?\}/g;
const TAG = /<[^<>]*>/g;
const MEHRZEILIG = /^((?:<[^<>]*>)*)\{([a-z0-9_]+)\.\.\.\}((?:<[^<>]*>)*)$/;

export function platzhalterIn(text: string): { name: string; mehrzeilig: boolean }[] {
  return [...text.matchAll(PLATZHALTER)].map((m) => ({ name: m[1]!, mehrzeilig: m[2] !== undefined }));
}

export function istMehrzeilenZeile(zeile: string): boolean {
  return MEHRZEILIG.test(zeile);
}

export function ersetze(text: string, werte: Werte): string {
  return text.replace(PLATZHALTER, (ganz, name: string) => {
    const w = werte[name];
    if (w === undefined) return ganz;
    return Array.isArray(w) ? w.join(" ") : w;
  });
}

function istLeer(w: string | string[] | undefined): boolean {
  return w !== undefined && (Array.isArray(w) ? w.length === 0 : w === "");
}

/** Ersetzt Zeilen samt mehrzeiligen Platzhaltern; Zeilen, die nur aus leeren Werten bestehen, entfallen. */
export function ersetzeZeilen(zeilen: string[], werte: Werte): string[] {
  const aus: string[] = [];
  for (const zeile of zeilen) {
    const mehr = MEHRZEILIG.exec(zeile);
    if (mehr) {
      const w = werte[mehr[2]!];
      if (w === undefined) aus.push(zeile);
      else for (const z of Array.isArray(w) ? w : w === "" ? [] : [w]) aus.push(mehr[1]! + z + mehr[3]!);
      continue;
    }
    const namen = platzhalterIn(zeile);
    const nurLeeres = namen.length > 0 && namen.every((p) => istLeer(werte[p.name]));
    if (nurLeeres && zeile.replace(PLATZHALTER, "").replace(TAG, "").trim() === "") continue;
    aus.push(ersetze(zeile, werte));
  }
  return aus;
}
